import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import * as PIXI from "pixi.js";
import Facade from "@/Facade";
import Linear from "gsap";
import {calculateTimeToMakeBets} from "@/managers/comunication/socket/utils";
import Config from "@/config/Config";

export default class MakeBetsContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {
    this.o = {
      t: 0
    }
    this.isStarted = false
    this.startPos = 0

    Signals.forceRoundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.makeBets.add(this.onMakeBets, this)

    this.makeBetsText = Facade.textFactory.getTextWithStyle('makeBets')
    this.addChild(this.makeBetsText)
    this.makeBetsText.pivot.set(this.makeBetsText.width / 2, this. makeBetsText.height / 2)
    this.alpha = 0

    this.progressBarContainer = new PIXI.Container()
    this.addChild(this.progressBarContainer)

    const progressBarBack = new PIXI.Graphics()
    progressBarBack.beginFill(0x293038)
    progressBarBack.drawRoundedRect(0, 0, 300, 3, 5)
    progressBarBack.endFill()
    progressBarBack.pivot.set(progressBarBack.width / 2, progressBarBack.height / 2)
    this.progressBarContainer.addChild(progressBarBack)

    this.progressBar = new PIXI.Graphics()
    this.progressBarContainer.addChild(this.progressBar)
    this.progressBar.position.set(-150, 0)

    this.progressBarContainer.y = 30

  }

  onProgress(percent) {
    this.progressBar.clear()
    this.progressBar.beginFill(0x5bff66)
    this.progressBar.drawRoundedRect(0, 0, (percent) * 3, 3, 5)
    this.progressBar.endFill()
    this.progressBar.pivot.set(0, this.progressBar.height / 2)
  }

  onMakeBets() {
    this.etalon = calculateTimeToMakeBets(Facade.model.totalTimeToMakeBets, Config.timeForExplosion)
    this.time = calculateTimeToMakeBets(Facade.model.makeBetsTime, Config.timeForExplosion)
    this.startPos = this.time < this.etalon ? 100 - ((this.time / this.etalon) * 100) : 0
    this.onProgress(this.startPos)
    TweenMax.to(this, .2, {alpha: 1})

    this.o.t = this.startPos
    TweenMax.to(this.o, this.time, {t: 100, ease:Linear.easeNone, onUpdate: () => {
      this.onProgress(this.o.t)
        if(this.o.t > 90 && !this.isStarted) {
          this.isStarted = true
          Signals.startPlane.dispatch()
        }
      }})
  }

  onRoundStart() {
    TweenMax.to(this, .2, {alpha: 0})
  }

  onRoundEnd() {
    this.isStarted = false
  }

}

